import {
  Paragraph,
  SectionType,
  TextRun,
  TabStopType,
  TabStopPosition,
  Tab,
  HeadingLevel,
  ExternalHyperlink,
  ISectionOptions,
} from 'docx'
import formatDate from '../common/date'
import { Resume } from '@/types/resume/v1'

const certificates = ({ certificates }: Resume.Schema): ISectionOptions => {
  return {
    properties: {
      type: SectionType.CONTINUOUS,
    },
    children: [
      new Paragraph({
        text: '\n',
      }),
      new Paragraph({
        text: 'Certificates',
        heading: HeadingLevel.HEADING_2,
      }),
      ...certificates.reduce<Paragraph[]>((acc, cert) => {
        return [...acc, ...createCertificationItem(cert)]
      }, []),
    ],
  }
}

const createCertificationItem = (cert: Resume.Certificate): Paragraph[] => {
  const item: Paragraph[] = []

  const certificateItemRun = cert.url
    ? new ExternalHyperlink({
      link: cert.url,
      children: [
        new TextRun({
          text: cert.name,
          bold: true,
        }),
      ],
    })
    : new TextRun({
      text: cert.name,
      bold: true,
    })

  item.push(
    new Paragraph({
      text: '\n',
    })
  )
  item.push(
    new Paragraph({
      children: [
        certificateItemRun,
        new TextRun({
          children: [new Tab()],
        }),
        new TextRun({
          text: formatDate(cert.date),
        }),
      ],
      tabStops: [
        {
          type: TabStopType.RIGHT,
          position: TabStopPosition.MAX,
        },
      ],
    })
  )
  item.push(
    new Paragraph({
      text: cert.issuer,
    })
  )
  return item
}

export default certificates
